module.exports = __webpack_public_path__ + "assets/img/0807.2ce16b3a.png";